import FirestoreService from "../firestore";
import { Residue } from "@/types/residue/residue.types";

interface FirestoreResponse {
    entity?: string;
    [key: string]: any;
}

export const residueService = {
    create: async (body: Omit<Residue, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "create-residue",
            body,
            "setup_residues",
            issuedBy
        )) as FirestoreResponse;

        const documentId = result?.entity;
        if (!documentId) {
            throw new Error("Failed to create residue: No ID returned");
        }
        return documentId;
    },

    edit: async (id: string, body: Partial<Residue>, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "edit-residue",
            { id, ...body },
            "setup_residues",
            issuedBy
        )) as FirestoreResponse;
        return result;
    },

    delete: async (id: string, issuedBy?: string) => {
        return FirestoreService.request(
            "delete-residue",
            { id },
            "setup_residues",
            issuedBy
        ) as Promise<FirestoreResponse>;
    }
}; 